import React from "react";
import { PERMISSIONS } from "./permission-maps.js";
import { useUserData } from "./useUserData.js";
import  ErrorPage from "./ErrorPage";

const hasPermission = ({ permissions, scopes }) => {
  if (scopes.length === 0) {
    return true;
  }
  return permissions.some((permission) => scopes.includes(permission));
};

function PermissionsGate({
  children,
  scopes = [],
  tiposUser = [],
  is_item = false
}) {
  const  {rol,permissions: permisos,  } = useUserData();
  const permissions = permisos.capacidades;
  const tipoUsuario = permisos.name;
  const permissionGranted = hasPermission({ permissions, scopes });
  const userGranted = tiposUser.some( (tipo) => tipo  == tipoUsuario)
  if(scopes.length > 0){
    if (!permissionGranted) return is_item ? null : <ErrorPage/>
  }
  if(tiposUser.length > 0){
    if (!userGranted ) return is_item ? null : <ErrorPage/>
  }
  return <>{children}</>;
}

export default React.memo(PermissionsGate)
